<template>
  <HSTable
    id="sync-error-table"
    :items="syncErrors"
    :columns="columns"
    show-filters
    :allow-selection="false"
    :show-pagination="false"
    :enable-download="true"
    :is-loading="false"
    export-file-name="sync-errors"
    :table-download-columns="tableDownloadColumns"
    @download="(download) => download(syncErrors)">
    <template #id="{ item }">
      {{ item.id }}
    </template>
    <template #name="{ item }">
      {{ item.name }}
    </template>
    <template #error="{ item }">
      {{ item.error }}
    </template>
  </HSTable>
</template>

<script setup lang="ts">
  import { capitalize, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  import HSTable from '@/common/components/controls/table/Table.vue';
  import TableColumn from '@/common/components/controls/table/TableColumn';
  import TableColumnTypes from '@/common/components/controls/table/TableColumnTypes';

  const i18n = useI18n();

  export interface ISyncError {
    id: string | number;
    name: string;
    error: string;
  }

  interface IProps {
    syncErrors: ISyncError[];
  }

  const { syncErrors } = defineProps<IProps>();

  const columns = ref({
    id: TableColumn.fromObject({
      label: capitalize(i18n.t('names.id')),
    }),
    name: TableColumn.fromObject({
      label: capitalize(i18n.t('names.name')),
    }),
    error: TableColumn.fromObject({
      label: capitalize(i18n.t('names.error')),
    }),
  });

  const tableDownloadColumns = ref([
    TableColumn.fromObject({
      label: capitalize(i18n.t('names.id')),
      property: 'id',
      type: TableColumnTypes.string,
    }),
    TableColumn.fromObject({
      label: capitalize(i18n.t('names.name')),
      property: 'name',
      type: TableColumnTypes.string,
    }),
    TableColumn.fromObject({
      label: capitalize(i18n.t('names.error')),
      property: 'error',
      type: TableColumnTypes.string,
    }),
  ]);
</script>
